import React from 'react';
import { Navigation, Footer } from '../components/Navigation';
import solypsizmBackground from '../assets/images/solypsizm-background.png';
import usePageTitle from '../hooks/usePageTitle';

const AboutPage = () => {
  usePageTitle('About | Solypsizm');
  return (
    <div className="min-h-screen text-white">
      <Navigation currentPage="about" />

      {/* Hero Section */}
      <section
        className="electric-blizzard-bg py-16 md:py-20 relative overflow-hidden"
        style={{
          backgroundImage: `url(${solypsizmBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          // Ensure hero section has enough height to show background
          minHeight: '60vh', // You can adjust this value as needed
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div className="max-w-4xl mx-auto px-4 text-center z-10 relative">
        </div>
      </section>

      {/* Main Content Wrapper with limited width charcoal background */}
      {/* Applying bg-charcoal directly to the max-width centered div */}
      <div className="max-w-4xl mx-auto bg-charcoal py-12 md:py-16 px-4 relative z-10">

        <div className="mb-12 md:mb-16">
          <h2 className="font-cinzel text-3xl md:text-4xl mb-6 text-neon-blue">The Soundscape</h2>
          <p className="mb-6 text-base md:text-lg">
            Solypsizm is an independent artist, songwriter, and producer project dedicated to creating rich, vivid music that explores the intersection of indie rock and indie pop. The name itself reflects a focus on internal exploration—building expansive auditory worlds from a solitary creative spark.
          </p>

          <h2 className="font-cinzel text-2xl md:text-3xl mb-6 text-neon-blue">Collaborative Spirit</h2>
          <p className="mb-6 text-base md:text-lg">
            While the vision starts with Solypsizm, the sound is brought to life through collaboration. I work closely with a diverse range of talented singers and instrumentalists, blending unique vocal textures and live performances with polished electronic production.
          </p>

          <h2 className="font-cinzel text-2xl md:text-3xl mb-6 text-neon-blue">The Genre-Bending Journey</h2>
          <p className="mb-6 text-base md:text-lg">
            From the driving energy of indie rock to the infectious melodies of indie pop, Solypsizm isn't confined to a single lane. It’s about the atmosphere—where every sound has its place and contributes to a greater emotional landscape.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutPage;
